import { aiProvenanceLabel, aiProvenanceShortLabel } from "./aiProvenance";
const lightboxHash = "gallery";
function updateAiProvenanceBadge(imageWrapper, provenance) {
    var _a;
    (_a = imageWrapper.querySelector(".m-ai-badge-overlay")) === null || _a === void 0 ? void 0 : _a.remove();
    const fullText = aiProvenanceLabel(provenance);
    if (fullText === null) {
        return;
    }
    const badge = document.createElement("span");
    badge.className = "m-ai-badge";
    badge.setAttribute("data-field-id", "AiProvenance.badge");
    badge.setAttribute("data-ai-badge-short", aiProvenanceShortLabel());
    badge.setAttribute("data-ai-badge-full", fullText);
    badge.setAttribute("aria-label", fullText);
    const overlay = document.createElement("span");
    overlay.className = "m-ai-badge-overlay";
    overlay.appendChild(badge);
    imageWrapper.appendChild(overlay);
}
/**
 * Check if location hash is #lightbox.
 *
 * @returns {boolean}
 */
function isHashLightbox() {
    const lightboxHashRegex = new RegExp(lightboxHash);
    return lightboxHashRegex.test(window.location.hash);
}
/**
 * Init SimpleLightbox library.
 */
function initSimpleLightbox() {
    // When you want use SimpleLightbox all galleries must have "id" attribute started with "gallery"
    const galleries = Array.from(document.querySelectorAll("[id^='gallery-']"));
    if (galleries.length === 0) {
        return;
    }
    void import(/* webpackChunkName: "simplelightbox" */ "simplelightbox")
        .then(({ default: SimpleLightbox }) => {
        galleries.forEach((item) => {
            const galleryItems = document.querySelectorAll(`#${item.id} a[data-lightbox]`);
            const gallery = new SimpleLightbox(`#${item.id} a[data-lightbox]`, {
                showCounter: false,
                history: false,
                fileExt: false,
                uniqueImages: false,
                captionSelector: "self",
                captionPosition: "outside",
                swipeClose: false,
                loop: galleryItems.length > 1 ? true : false,
                overlayOpacity: 0.95,
                fadeSpeed: 150,
                animationSpeed: 150,
                scrollZoom: false,
            });
            window.addEventListener("hashchange", () => {
                if (!isHashLightbox()) {
                    gallery.close();
                }
            });
            gallery.on("shown.simplelightbox", () => {
                var _a, _b, _c;
                if (!isHashLightbox()) {
                    history.pushState(null, "", `${window.location.pathname}#${lightboxHash}`);
                    // Set skip_group_scroll to true when entering gallery.
                    // The closed.simplelightbox event doesn't fire when closing the gallery with the back button.
                    // https://restaumatic.atlassian.net/browse/RS-6021
                    Skubacz.configuration.menu.skip_group_scroll = true;
                }
                // Propagate alt text to the lightbox <img> — simplelightbox creates its own
                // <img> with only src set. Prefer the anchor's data-alt (set for both the icon
                // and thumbnail variants, so the icon trigger without a thumbnail <img> still
                // has an alt), falling back to a thumbnail <img>'s alt.
                const anchor = gallery.relatedElements[gallery.currentImageIndex];
                const alt = (_c = (_a = (anchor instanceof HTMLElement ? anchor.dataset.alt : undefined)) !== null && _a !== void 0 ? _a : (_b = anchor === null || anchor === void 0 ? void 0 : anchor.querySelector("img")) === null || _b === void 0 ? void 0 : _b.alt) !== null && _c !== void 0 ? _c : "";
                const currentImage = gallery.currentImage;
                currentImage === null || currentImage === void 0 ? void 0 : currentImage.setAttribute("alt", alt);
                const imageWrapper = currentImage === null || currentImage === void 0 ? void 0 : currentImage.parentElement;
                if (imageWrapper != null) {
                    updateAiProvenanceBadge(imageWrapper, anchor instanceof HTMLElement
                        ? anchor.dataset.aiProvenance
                        : undefined);
                }
            });
            gallery.on("closed.simplelightbox", (event) => {
                var _a;
                if (isHashLightbox()) {
                    history.back();
                    // Restore focus to the element that opened the gallery for better accessibility.
                    (_a = event.target) === null || _a === void 0 ? void 0 : _a.focus();
                }
            });
        });
    })
        .catch((error) => {
        console.error("Failed to load SimpleLightbox", error);
    });
}
/**
 * Gallery.
 *
 * https://simplelightbox.com/
 */
export default {
    init: function () {
        initSimpleLightbox();
    },
};
